<template>
  <table-search-wrapper
    class="fx-search-bar"
    :show-search-bar="searchItems.length > 0"
    :search-items="searchItems"
    :show-adv-search="showAdvSearch"
    :hide-header-line="hideHeaderLine"
    :show-reset-at-simple-mode="showResetAtSimpleMode"
    @search="searchBarChanged"
    @change-height="setContentHeight"
  >
    <template v-for="s in searchItemsSlots" #[s]="itemData">
      <slot :name="s" v-bind="itemData"></slot>
    </template>
  </table-search-wrapper>
</template>

<script lang="ts">
import { defineComponent, PropType, computed } from 'vue'
import TableSearchWrapper from '../../page-table-v2/src/table-search-wrapper.vue'
import { TagItem } from '../../page-table-v2/src/types'
import { Utils } from '../../page-table-v2/src/utils'

export default defineComponent({
  name: 'SearchBar',
  components: { TableSearchWrapper },
  props: {
    showAdvSearch: {
      type: Boolean,
      default: true,
    },
    // 搜索条件
    searchItems: {
      type: Array as PropType<any[]>,
      default: () => [],
    },
    hideHeaderLine: Boolean,
    showResetAtSimpleMode: Boolean,
  },
  emits: ['search', 'height-changed'],
  setup (props, { emit }) {
    const searchItemsSlots = computed(() => {
      const result: string[] = []
      props.searchItems.forEach(si => {
        if (si.type === 'slot' && si.slotName) {
          result.push(si.slotName)
        }
      })
      return result
    })

    const searchBarChanged = (searchArr: TagItem[], searchType: number) => {
      let currentSearchTags: TagItem[] = []
      if (searchType === 1) { // 简单搜索，只有一个搜索项
        const idx = currentSearchTags.findIndex(st => st.key === searchArr[0].key)
        if (idx > -1) {
          currentSearchTags[idx] = searchArr[0]
        } else {
          currentSearchTags.push(searchArr[0])
        }
      } else { // 高级搜索
        currentSearchTags = searchArr
      }
      emit('search', { ...Utils.getSearchParams(currentSearchTags).mapParams })
    }

    const setContentHeight = (val: number) => {
      emit('height-changed', val)
    }

    return {
      searchItemsSlots,
      searchBarChanged,
      setContentHeight,
    }
  },
})
</script>
